import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getMeterReading = async (meterId) => {
  const data = await request.get(
    `/RentPlace/meter/${meterId}/reading`,
    {},
    'При загрузке показаний счетчика произошла ошибка',
    []
  );
  return data;
};

const useMeterReading = (meterId, options) =>
  useQuery([queries.meterReading, meterId], () => getMeterReading(meterId), {
    placeholderData: [],
    enabled: !!meterId,
    ...options
  });

export default useMeterReading;
